"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _lodash = require("lodash");
var _fa = _interopRequireDefault(require("../util/fa"));
var _excluded = ["fieldApi", "fieldState"],
  _excluded2 = ["forwardedRef", "value", "id", "dateFormat", "icon"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var moment = require('moment/moment');
var DateInputBasic = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function DateInputBasic(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, DateInputBasic);
    _this = _callSuper(this, DateInputBasic, [props]);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.state = {
      id: _this.props.id || (0, _lodash.uniqueId)("field-")
    };
    return _this;
  }
  (0, _inherits2["default"])(DateInputBasic, _React$Component);
  return (0, _createClass2["default"])(DateInputBasic, [{
    key: "onFocus",
    value: function onFocus(e) {
      var _this$props = this.props,
        fieldState = _this$props.fieldState,
        fieldApi = _this$props.fieldApi,
        dateFormat = _this$props.dateFormat;
      var setValue = fieldApi.setValue;
      var s = $(this.refs['input']);
      if (s.val().length === 0 && !fieldState.value) {
        s.val(moment().format(dateFormat));
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        fieldApi = _this$props2.fieldApi;
      var setValue = fieldApi.setValue;
      setValue(e.target.value);
      if (onChange) {
        onChange(e);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var fieldApi = this.props.fieldApi;
      var setTouched = fieldApi.setTouched;
      var s = $(this.refs['input']);
      s.data('datetimepicker').hide();
      setTouched();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fieldState.value !== this.props.fieldState.value && this.props.fieldState.value === undefined) {
        var s = $(this.refs['input']);
        s.data('datetimepicker').clear();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var s = $(this.refs['input']);
      var options = this.props.options;
      options.format = this.props.dateFormat;
      options.useCurrent = false;
      if (s.val()) {
        options.date = moment(s.val(), this.props.dateFormat);
      }
      s.datetimepicker(options);
      s.on('blur', this.onBlur).on('change.datetimepicker', this.onChange).on('focus', this.onFocus);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fieldApi = _this$props3.fieldApi,
        fieldState = _this$props3.fieldState,
        props = (0, _objectWithoutProperties2["default"])(_this$props3, _excluded);
      var forwardedRef = props.forwardedRef,
        value = props.value,
        id = props.id,
        dateFormat = props.dateFormat,
        icon = props.icon,
        rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);
      value = value ? value : fieldState.value;
      if (value !== undefined && value !== null) {
        value = moment(value, ["YYYY-MM-DD", dateFormat]).format(dateFormat);
      }
      return /*#__PURE__*/_react["default"].createElement(_reactstrap.InputGroup, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "input-group-prepend"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-group-text"
      }, /*#__PURE__*/_react["default"].createElement(_fa["default"], {
        icon: icon
      }))), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
        defaultValue: value,
        disabled: this.props.disabled,
        "data-toggle": "datetimepicker",
        "data-target": "#" + this.state.id,
        id: this.state.id,
        ref: "input"
      }, rest)));
    }
  }]);
}(_react["default"].Component);
DateInputBasic.propTypes = {
  label: _propTypes["default"].string,
  type: _propTypes["default"].string,
  options: _propTypes["default"].object,
  dateFormat: _propTypes["default"].string,
  icon: _propTypes["default"].string
};
DateInputBasic.defaultProps = {
  label: '',
  type: 'text',
  options: {},
  fieldState: {},
  id: null,
  dateFormat: 'MM/DD/YYYY',
  icon: 'calendar'
};